import { ButtonList } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { User } from 'lib-shared-types-api';
import { MouseEventHandler, useCallback } from 'react';

import { useAppSearchParams } from 'utils/url/useAppSearchParams';

import { ConversationsTableRowMenuItemBaseProps } from '../conversationsTableRowMenuItem.types';

type ConversationsTableRowMenuFilterProps = {
  /** The user to filter the conversations by. */
  user: User;
  /** Whether the user is the assigned agent. */
  isAssignee?: boolean;
} & ConversationsTableRowMenuItemBaseProps;

/** Represents the component for filtering by similar conversations. */
export const ConversationsTableRowMenuFilter = ({
  user,
  isAssignee,
  toggleDropdown,
}: ConversationsTableRowMenuFilterProps): JSX.Element => {
  const { replaceParams } = useAppSearchParams('/conversations');

  /** Handles filtering the conversations by the user. */
  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>(() => {
    toggleDropdown();

    replaceParams({ [isAssignee ? 'agent' : 'requester']: user.id });

    if (isAssignee) {
      ampli.conversationsFilterAgentClicked({
        id: user.id,
      });
    } else {
      ampli.conversationsFilterContactClicked({
        id: user.id,
      });
    }
  }, [isAssignee, replaceParams, toggleDropdown, user.id]);

  return (
    <ButtonList.Item onClick={handleClick}>
      Filter conversations
    </ButtonList.Item>
  );
};
